// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../../../app';
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
import { resolve } from '../../../../init/store';

app.factory('SharedAccountShare', modal);

/** @ngInject */
function modal($uibModal) {

    return function (account) {

        return $uibModal.open({
            templateUrl: require('./shared-accounts-share.html'),
            controller: controller,
            controllerAs: 'vm',
            resolve: {users,labels},
        }).result;

        /** @ngInject */
        function controller(
            $rootScope,
            $scope,
            $state,
            $translate,
            $uibModalInstance,
            CompanyUser,
            ConfirmDeleteModal,
            SharedAccountsService,
			UserLabelsService,
			labels,
            users
        ) {
            this.cancel = () => $uibModalInstance.dismiss();
            this.close = () => $uibModalInstance.close();
            $scope.account = account;
            $scope.newUserIdentifier = null;
			$scope.selectedLabels=[];
			$scope.labels=labels;
            $scope.userIdentifier = null;
            const companyId = $state.params.companyId;
            
            $scope.st = new SmartTable();
            
            
            $scope.identifyUser = function() {
                $scope.message = null;
                    $scope.userIdentifier = $scope.newUserIdentifier;

                    if ($scope.userIdentifier == $scope.currentSaaspassId) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_is_the_same';
                    } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                        $scope.successResult = false;
                        $scope.showVerification = false;

                        $scope.message = 'groups_users.user_email_is_the_same';
                    } else {
                        CompanyUser.identifyCompanyUser({
                            companyId : companyId,
                            uid : encodeURIComponent($scope.userIdentifier)
                        }, function(data) {
                            if ((data.id && data.id == $scope.currentCompanyUserId) ||
                                    (data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId)) {
                                $scope.successResult = false;
                                $scope.showVerification = false;

                                $scope.message = 'groups_users.user_is_the_same';
                            } else {
                                $scope.successResult = true;
                                $scope.showVerification = false;
                                $scope.companyUser = data;

                                $scope.message = 'groups_users.user_found';
                            }
                        }, function(response) {
                            $scope.successResult = false;
                            $scope.companyUser = null;

                            $scope.showVerification = $scope.enableVerification && !$scope.successResult
                                    && $rootScope.emailPattern.test($scope.userIdentifier);

                            if (response.status == 404) {
                                $scope.message = 'groups_users.user_not_found';
                            } else {
                                $scope.message = response.data.message;
                            }
                        });
                    }
            }
            
            
            var errorInitUsers = function(error){
                //TODO handle error on user populate request
                $scope.spAlert = new SpAlert('danger', error.data.message);
            }
            
            var errorUnshareUser = function(error){
                $scope.spAlert = new SpAlert('danger', error.data.message);
            }
            
            $scope.unshare = function(saaspassId){
                $scope.type = 'SINGLE';
                $scope.saaspassId = saaspassId;
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
                    .then(() => $scope.deleteConfirmedSingle());
            }
            
            $scope.cancleSearch = function(){
                $scope.userIdentifier = null;
                $scope.successResult = null;
                $scope.showVerification = false;
                $scope.companyUser = null;
                $scope.message = null;
                $scope.newUserIdentifier = null;
            }
            
            $scope.share = function(saaspassId){
                
                var param = {
                        companyId : companyId,
                        id : account.id,
                        saaspassId : saaspassId
                }
                SharedAccountsService.shareCompanyServiceAccounts(param, {}, function(response){
                    initUsers();
                    $scope.spAlert = new SpAlert('success', 'shared_accounts.messages.share_account');
                }, errorUnshareUser);
                
               
            }
			$scope.shareWishLabels= function(){
				 var param = {
                        companyId : companyId,
                        id : account.id
				}
				SharedAccountsService.shareServiceAccountWithLabels(param,$scope.selectedLabels,function(response){
                    initUsers();
					$scope.selectedLabels=[];
                    $scope.spAlert = new SpAlert('success', 'shared_accounts.messages.share_account');
                },function(error){});
			}
			$scope.clickLabel=function(label) {
				var indexOfLabel=$scope.selectedLabels.indexOf(label);
				if(indexOfLabel >= 0){
					$scope.selectedLabels.splice(indexOfLabel,1)
				} else {
					if(label.name === "ALL_USERS"){
						$scope.selectedLabels=[];
					
					} 
					$scope.selectedLabels.push(label);
				}
			}
			$scope.isCheckedLabel=function(label){
				var indexOfLabel=$scope.selectedLabels.indexOf(label);
				return indexOfLabel >= 0;
			}
            $scope.isCheckboxDisabled=function(label) {
				var isIt = (label.name !== "ALL_USERS") && ($scope.selectedLabels.length==1) && ($scope.selectedLabels[0].name==="ALL_USERS");
				return isIt;
			}
            $scope.deleteConfirmedSingle = function(){
                var param = {
                        companyId : companyId,
                        id : account.id,
                        saaspassId : $scope.saaspassId
                }
                SharedAccountsService.unshareCompanyServiceAccounts(param, {}, function(response){
                    initUsers();
                    $scope.spAlert = new SpAlert('success', 'shared_accounts.messages.unshare_account');
                    
                   
                }, errorUnshareUser);
            }
            
            $scope.deleteConfirmed = function() {
                
                
                
                var param = {
                        companyId: companyId,
                        id : account.id
                    }         
                    
                    
                
                    var data = getSelectedSaaspassIds();
                    
                    
                    SharedAccountsService.unshareSelectedCompanyServiceAccounts(param, data, function(response){
                        initUsers();
                        const key = 'shared_accounts.messages.unshare_account';
                        $scope.spAlert = new SpAlert('success', key);
 
                    }, function (error){
                        $scope.spAlert = new SpAlert('danger', error.data.message);
                    });
            }
            
            $scope.unshareSelected = function(){
                $scope.type = 'ALL';
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
                    .then(() => $scope.deleteConfirmed());
            }
            
            $scope.selectUser = function(position){
                
            }
            
            $scope.unselectUser = function(position){
                
            }
            
            var initUsers = function(){
                SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({companyId: companyId, id: account.id},{}, function(response){
                    $scope.users = response.sharedUsersList;
                }, errorInitUsers);
                $scope.cancleSearch();
            }
            
            $scope.users = users;
			

            function getSelectedSaaspassIds() {
                return $scope.st.selectedItems.map((user) => user.saaspassId);
            }
        }

        /** @ngInject */
        function users(SharedAccountsService) {
            return SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({
                companyId: resolve.companyId,
                id: account.id,
            }, {}).$promise.then(({sharedUsersList}) => {
                return sharedUsersList;
            });
        }

		/** @ngInject */
        function labels(UserLabelsService) {
            return UserLabelsService.getLabelsDefaultsIncluded({
                companyId: resolve.companyId
            }, {}).$promise.then((labels) => {
                return labels;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/shared-accounts-share.modal.js